import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
// Importiamo il servizio API configurato invece di axios direttamente
import { apiGet } from '../services/api.service';
import axios from 'axios';
import EmployeeSelect from '../components/EmployeeSelect';
import VehicleSelect from '../components/VehicleSelect';
import { getNodeApiUrl } from '../config/api.config';
import AbsenceDetailsPanel from '../components/AbsenceDetailsPanel';
import CustomerSelect from '../components/CustomerSelect';
import MySelect from '../components/MySelect';
import { createPortal } from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDay, faCalendarWeek, faCalendarAlt, faCalendarPlus, faLayerGroup, faUserGroup, faCar, faToolbox, faTrash, faPencil, faSave, faPlus, faTimes, faClock, faHourglassStart, faHourglassEnd, faFilter } from '@fortawesome/free-solid-svg-icons';
import JobSelect from '../components/JobSelect';
import EquipmentSelect from '../components/EquipmentSelect';
import RightModal from '../components/templates/RightModal';
import { closeModal, selectRightModalIsOpen, selectRightModalmode, selectRightModalData, setModal } from '../redux/rightModalSlice';
import ViewAppointment from '../components/calendar/ViewAppointment';
import ViewJob from '../components/jobsPage/ViewJob';
import SchedulingOffcanvas from '../components/calendar/SchedulingOffcanvas';
import AppointmentDetailsModal from '../components/calendar/AppointmentDetailsModal';
import AppointmentRescheduleModal from '../components/calendar/AppointmentRescheduleModal';
import AppointmentDeleteModal from '../components/calendar/AppointmentDeleteModal';
import GenericAppointmentDetailsModal from '../components/calendar/GenericAppointmentDetailsModal';
import GenericAppointmentEditOffcanvas from '../components/calendar/GenericAppointmentEditOffcanvas';
import AbsenceDetailsModal from '../components/calendar/AbsenceDetailsModal';
import AbsenceOffcanvas from '../components/absences/AbsenceOffcanvas';

// Import CSS per il calendario
// Nota: utilizziamo un import assoluto per evitare problemi con i percorsi relativi
import '/src/styles/calendar.css';

// Stile CSS personalizzato unificato che funziona in tutte le viste
const GradientStyle = `
  /**********************************************
   * STILE PROFESSIONALE PER CONTROLLI DI NAVIGAZIONE
   **********************************************/
  /* Pulsanti di navigazione e intestazione */
  .fc-header-toolbar {
    padding: 8px 16px !important;
    margin-bottom: 0 !important;
  }

  /* Titolo centrale */
  .fc-toolbar-title {
    font-size: 1.5rem !important;
    font-weight: 600 !important;
    color: #374151 !important;
  }

  /* Pulsanti di navigazione (prev/next) */
  .fc-prev-button, .fc-next-button {
    background-color: #f3f4f6 !important;
    border: 1px solid #e5e7eb !important;
    box-shadow: none !important;
    color: #4b5563 !important;
    padding: 0.4rem 0.8rem !important;
    margin: 0 4px !important;
    transition: all 0.2s !important;
    border-radius: 6px !important;
  }
  
  .fc-prev-button:hover, .fc-next-button:hover {
    background-color: #e5e7eb !important;
    color: #111827 !important;
  }

  /* Pulsanti di visualizzazione (month, week, day, list) */
  .fc-button-group {
    box-shadow: none !important;
    overflow: hidden !important;
    border-radius: 6px !important;
    border: 1px solid #e5e7eb !important;
  }
  
  .fc-button-group .fc-button {
    background-color: #ffffff !important;
    border: none !important;
    box-shadow: none !important;
    color: #4b5563 !important;
    padding: 0.4rem 1rem !important;
    transition: all 0.2s !important;
  }

  .fc-button-group .fc-button:not(:last-child) {
    border-right: 1px solid #e5e7eb !important;
  }

  .fc-button-group .fc-button-active {
    background-color: #383838 !important;
    color: white !important;
  }

  .fc-button-group .fc-button:hover:not(.fc-button-active) {
    background-color: #f3f4f6 !important;
    color: #111827 !important;
  }

  /**********************************************
   * RESET COMPLETO STILI FULLCALENDAR
   **********************************************/
  /* Elimina il punto bianco nella vista mese */
  .fc-daygrid-event-dot {
    display: none !important;
  }
  
  /* Imposta tutti gli eventi a blocco */
  .fc-h-event, .fc-v-event, .fc-daygrid-event, .fc-timegrid-event {
    display: block !important;
    border-width: 2px !important; 
  }
  
  /* Forza il colore anche nei contenitori esterni */
  .fc-daygrid-event, .fc-timegrid-event {
    background-color: var(--event-color) !important;
    border-color: var(--event-color) !important;
  }
  
  /* Vista mensile - evento a blocco */
  .fc-daygrid-day-events .fc-daygrid-event {
    display: block !important;
    background-color: var(--event-color) !important;
    border-color: var(--event-color) !important;
    margin: 2px 0 !important;
    padding: 2px !important;
  }
  
  /* Rimuovi il colore di sfondo bianco */
  .fc-daygrid-day-events .fc-event-main,
  .fc-timegrid-event .fc-event-main,
  .fc-timegrid-event .fc-event-main-frame {
    background-color: transparent !important;
    color: white !important;
  }
  
  /* Fix specifico per vista mensile */
  .fc-daygrid-block-event .fc-event-time,
  .fc-daygrid-block-event .fc-event-title {
    padding: 1px 2px !important;
    color: white !important;
    font-weight: bold !important;
  }
  
  /* Vista settimanale e giornaliera */
  .fc-timegrid-event {
    background-color: var(--event-color) !important;
    border-color: var(--event-color) !important;
    min-height: 25px !important;
  }
  
  /* Fix contenitore evento in vista settimanale per evitare sovrapposizioni */
  .fc-timegrid-event-harness {
    margin: 0 !important;
    z-index: 2 !important;
  }
  
  /* Orario e titolo dell'evento */
  .fc-event-time, .fc-event-title {
    color: white !important;
    font-weight: bold !important;
    text-shadow: 0 0 2px rgba(0,0,0,0.5) !important;
  }
  
  /**********************************************
   * GRADIENTI
   **********************************************/
  /* Applica il gradiente per eventi con più utenti */
  .gradient-event {
    background-image: var(--gradient-bg) !important;
    background-color: transparent !important;
  }
  
  .fc-event.gradient-event .fc-event-main,
  .fc-daygrid-event.gradient-event .fc-event-main,
  .fc-timegrid-event.gradient-event .fc-event-main {
    background-image: var(--gradient-bg) !important;
    background-color: transparent !important;
  }
  
  /* Stile per quando un evento non ha utenti assegnati */
  .fc-event.no-users {
    background-color: #cccccc !important;
    border-color: #999999 !important;
  }
  
  /* Eventi giornalieri nel calendario */
  .fc-daygrid-day-events {
    margin: 0.5rem !important;
  }
  
  /* Forza la visualizzazione di tutti gli eventi */
  .fc-daygrid-more-link {
    display: none !important; /* Nasconde il link '+altro' */
  }
  
  /* Assicurati che tutti gli eventi vengano mostrati */
  .fc-daygrid-day-events {
    max-height: none !important; /* Rimuove l'altezza massima */
    overflow: visible !important; /* Permette il contenuto di superare i confini */
  }

  /* Visualizzazione tooltip */
  .has-tooltip {
    cursor: pointer;
  }
`;

// Inserisci lo stile nella pagina
const insertGradientStyle = () => {
  const styleElement = document.createElement('style');
  styleElement.textContent = GradientStyle;
  document.head.appendChild(styleElement);
  return () => {
    document.head.removeChild(styleElement);
  };
};

// Funzione per aggiungere stili globali che risolvono il problema dei dropdown
const applyGlobalSelectStyles = () => {
    // Rimuove eventuali stili esistenti
    const existingStyle = document.getElementById('calendar-select-fix');
    if (existingStyle) existingStyle.remove();

    // Crea un nuovo elemento style
    const styleEl = document.createElement('style');
    styleEl.id = 'calendar-select-fix';
    
    // CSS specifico per far funzionare correttamente i dropdown sul calendario
    styleEl.textContent = `
        /* Aumenta lo z-index di tutti i container select */
        body .select__control,
        body .react-select__control,
        body div[class*="control"] {
            z-index: 100 !important;
            position: relative !important;
        }

        /* Overlay che blocca gli eventi quando un menu è aperto */
        .dropdown-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: transparent;
            z-index: 9998;
            pointer-events: auto;
        }
        
        /* Menu dropdown e portali */
        body .select__menu-portal,
        body .react-select__menu-portal,
        body div[class*="menu-portal"],
        body .select__menu,
        body .react-select__menu,
        body div[class*="menu"][role="listbox"] {
            z-index: 100000 !important;
            position: absolute !important;
            background-color: white !important;
            border: 1px solid #d8dee2 !important;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
        }
        
        /* Elementi del menu */
        body .select__option,
        body .react-select__option,
        body div[class*="option"] {
            position: relative;
            z-index: 100000 !important;
            pointer-events: auto !important;
            background-color: white !important;
            color: #333 !important;
        }
        
        /* Stato hover degli elementi del menu */
        body .select__option:hover,
        body .react-select__option:hover,
        body div[class*="option"]:hover {
            background-color: #f5f5f5 !important;
        }
        
        /* Elementi selezionati nel menu */
        body .select__option--is-selected,
        body .react-select__option--is-selected,
        body div[class*="option"][aria-selected="true"] {
            background-color: #e6f7ff !important;
            color: #333 !important;
        }
        
        /* Forza il rendering sopra il calendario */
        .fc-event,
        .fc-daygrid-event,
        .fc-timegrid-event {
            z-index: 10 !important;
        }
        
        /* Contenitori del menu select */
        .calendar-select-container {
            position: relative;
            z-index: 99999;
        }
    `;
    
    // Inserisce lo stile nell'header
    document.head.appendChild(styleEl);
    return () => {
        if (document.getElementById('calendar-select-fix')) {
            document.getElementById('calendar-select-fix').remove();
        }
    };
};

// Componente wrapper per i dropdown che garantisce che siano sempre sopra altri elementi
const SelectOverlay = ({ isOpen, onClose }) => {
    if (!isOpen) return null;
    
    return createPortal(
        <div 
            className="dropdown-overlay" 
            onClick={onClose}
        />,
        document.body
    );
};

// Componente wrapper che gestisce i dropdown e garantisce che siano sempre sopra altri elementi
const DropdownWrapper = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    
    // Monitora quando il dropdown viene aperto/chiuso
    const handleMenuOpen = () => setIsOpen(true);
    const handleMenuClose = () => setIsOpen(false);
    
    // Clona il figlio aggiungendo le props necessarie
    const childWithProps = React.Children.map(children, child => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                onMenuOpen: handleMenuOpen,
                onMenuClose: handleMenuClose,
                menuPortalTarget: document.body,
                menuPosition: "fixed",
                styles: {
                    ...(child.props.styles || {}),
                    menu: (provided) => ({
                        ...(child.props.styles?.menu ? child.props.styles.menu(provided) : provided),
                        zIndex: 100000,
                        position: "absolute"
                    }),
                    menuPortal: (provided) => ({
                        ...(child.props.styles?.menuPortal ? child.props.styles.menuPortal(provided) : provided),
                        zIndex: 100000
                    }),
                    control: (provided) => ({
                        ...(child.props.styles?.control ? child.props.styles.control(provided) : provided),
                        zIndex: 100
                    })
                }
            });
        }
        return child;
    });

    return (
        <div className="calendar-select-container">
            {childWithProps}
            <SelectOverlay isOpen={isOpen} onClose={handleMenuClose} />
        </div>
    );
};

// Stili in-line per il layout verticale
const styles = {
    calendarContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        minHeight: 'calc(100vh - 160px)' // Altezza minima per evitare compressione eccessiva
    },
    planningPanel: {
        width: '100%',
        transition: 'height 0.3s ease-in-out',
        overflow: 'visible',
        backgroundColor: '#ffffff',
        borderRadius: '0.5rem',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '0'
    },
    planningPanelCollapsed: {
        height: '0',
        padding: '0',
        margin: '0',
        overflow: 'hidden'
    },
    planningContent: {
        flex: '1 1 auto',
        padding: '15px',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'visible',
        height: 'auto',
        width: '100%'
    },
    calendarSection: {
        flex: '1 1 auto',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minHeight: '500px' // Altezza minima per il calendario
    },
    calendarCard: {
        flex: '1 1 auto',     // Permette alla card di crescere per occupare lo spazio disponibile
        backgroundColor: '#ffffff',
        borderRadius: '0.5rem',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
        border: '1px solid #edf2f7',
        display: 'flex',
        flexDirection: 'column'
    },
    calendarWrapper: {
        flex: '1 1 auto',
        position: 'relative',
        overflow: 'visible', // Cambiato da 'auto' per evitare scrollbar interne
        padding: '15px',
        display: 'flex',
        flexDirection: 'column'
    },
    sectionHeader: {
        borderLeft: '4px solid #3182ce',
        paddingLeft: '0.75rem',
        marginBottom: '1rem',
        paddingTop: '0.25rem',
        paddingBottom: '0.25rem'
    },
    actionButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontWeight: '500',
        padding: '0.5rem 1rem',
        borderRadius: '0.375rem',
        transition: 'all 150ms ease-in-out',
        cursor: 'pointer',
        border: 'none',
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
    },
    primaryButton: {
        backgroundColor: '#3182ce',
        ':hover': {
            backgroundColor: '#2c5282'
        }
    },
    successButton: {
        backgroundColor: '#48bb78',
        ':hover': {
            backgroundColor: '#38a169'
        }
    },
    dangerButton: {
        backgroundColor: '#e53e3e',
        ':hover': {
            backgroundColor: '#c53030'
        }
    }
};

const JobsCalendar = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const accountData = useSelector((state) => state.account.data);
    
    // Applica gli stili globali per fix dropdown quando il componente si monta
    useEffect(() => {
        return applyGlobalSelectStyles();
    }, []);
    
    // Gestisce il ritorno dalla pagina di caricamento ore per riaprire il dettaglio commessa
    useEffect(() => {
        if (location.state?.openJobDetail && location.state?.jobId) {
            setSelectedJobId(location.state.jobId);
            setSelectedAppointment(location.state.appointmentId ? { _id: location.state.appointmentId } : null);
            dispatch(setModal({ mode: 'view', percentuageWidth: 80 }));
            // Pulisci lo state per evitare che si riapra al refresh
            window.history.replaceState({}, document.title);
        }
    }, [location.state, dispatch]);
    const [isLoading, setIsLoading] = useState(true);
    const [events, setEvents] = useState([]);
    const [selectedJobId, setSelectedJobId] = useState(null);
    
    // Redux per gestire la modale laterale
    const rightModalIsOpen = useSelector(selectRightModalIsOpen);
    const rightModalMode = useSelector(selectRightModalmode);
    const rightModalData = useSelector(selectRightModalData);
    const [selectedAppointment, setSelectedAppointment] = useState(null);
    const [selectedAbsence, setSelectedAbsence] = useState(null);
    const [showAbsencePanel, setShowAbsencePanel] = useState(false);
    
    // Funzione per formattare la data in formato ISO (YYYY-MM-DD)
    const formatDateToISO = (date) => {
        // Assicuriamoci di restituire la data completa con orario (non solo YYYY-MM-DD)
        return date instanceof Date ? date.toISOString() : date;
    };
    
    // Stati per la pianificazione
    const [jobs, setJobs] = useState([]);
    const [selectedJob, setSelectedJob] = useState(null);
    const [startDate, setStartDate] = useState(formatDateToISO(new Date()));
    const [endDate, setEndDate] = useState(formatDateToISO(new Date()));
    const [startTime, setStartTime] = useState('09:00');
    const [endTime, setEndTime] = useState('18:00');
    const [planningNotes, setPlanningNotes] = useState('');
    
    // Stati per le risorse
    const [employees, setEmployees] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [equipments, setEquipments] = useState([]);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [selectedVehicles, setSelectedVehicles] = useState([]);
    const [selectedEquipments, setSelectedEquipments] = useState([]);
    
    // Stati per i clienti
    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    
    // Stato per le pianificazioni
    const [plannings, setPlannings] = useState([]);
    const [isLoadingResources, setIsLoadingResources] = useState(false);
    const [currentDate, setCurrentDate] = useState('');
    
    // Stato per l'offcanvas di pianificazione rapida
    const [showSchedulingOffcanvas, setShowSchedulingOffcanvas] = useState(false);
    const [schedulingDate, setSchedulingDate] = useState(null);
    
    // Stato per la modale dei dettagli appuntamento
    const [showAppointmentModal, setShowAppointmentModal] = useState(false);
    const [modalAppointment, setModalAppointment] = useState(null);
    
    // Stato per la modale di reschedule (drag & drop / resize)
    const [showRescheduleModal, setShowRescheduleModal] = useState(false);
    const [rescheduleData, setRescheduleData] = useState({
        appointment: null,
        newStart: null,
        newEnd: null,
        changeType: null, // 'drop' o 'resize'
        revertFunc: null
    });
    
    // Stato per la modale di eliminazione appuntamento
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteModalData, setDeleteModalData] = useState({
        appointment: null,
        isMultiDay: false
    });
    
    // Stato per la modale dettagli appuntamento generico
    const [showGenericAppointmentModal, setShowGenericAppointmentModal] = useState(false);
    const [genericModalAppointment, setGenericModalAppointment] = useState(null);
    
    // Stato per l'offcanvas di modifica appuntamento generico
    const [showGenericEditOffcanvas, setShowGenericEditOffcanvas] = useState(false);
    const [genericEditAppointment, setGenericEditAppointment] = useState(null);
    
    // Stato per la modale dettagli assenza
    const [showAbsenceModal, setShowAbsenceModal] = useState(false);
    const [absenceModalData, setAbsenceModalData] = useState(null);
    
    // Stato per l'offcanvas di modifica assenza
    const [showAbsenceOffcanvas, setShowAbsenceOffcanvas] = useState(false);
    const [absenceToEdit, setAbsenceToEdit] = useState(null);
    
    // Aggiorna il calendario quando necessario
    // Nota: Non aggiungiamo più gli eventi manualmente qui perché sono già gestiti dalla configurazione del calendario
    const refreshCalendar = () => {
        if (calendarApiRef.current) {
            calendarApiRef.current.refetchEvents();
        }
    };
    
    // Aggiorna gli eventi del calendario quando viene chiusa la modale
    useEffect(() => {
        // Verifichiamo se la modale è stata appena chiusa
        if (rightModalIsOpen === false) {
            // Richiedi al calendario di aggiornare gli eventi
            refreshCalendar();
        }
    }, [rightModalIsOpen]);
    
    // Funzione per caricare le assenze dei collaboratori dal server
    const fetchEmployeeAbsences = useCallback(async (start, end) => {
        try {
            if (!accountData?._id) {
                console.error('🚫 accountId non disponibile per caricamento assenze');
                return [];
            }
            const accountId = accountData._id;

            // Assicuriamoci di avere date in formato corretto
            let startDate, endDate;
            
            if (typeof start === 'string') {
                startDate = start;
            } else if (start instanceof Date) {
                startDate = formatDateToISO(start);
            } else {
                // Usiamo un mese indietro come default
                const defaultStart = new Date();
                defaultStart.setHours(0, 0, 0, 0);
                defaultStart.setMonth(defaultStart.getMonth() - 1);
                startDate = formatDateToISO(defaultStart);
            }
            
            if (typeof end === 'string') {
                endDate = end;
            } else if (end instanceof Date) {
                endDate = formatDateToISO(end);
            } else {
                // Usiamo un mese avanti come default
                const defaultEnd = new Date();
                defaultEnd.setHours(23, 59, 59, 999);
                defaultEnd.setMonth(defaultEnd.getMonth() + 1);
                endDate = formatDateToISO(defaultEnd);
            }
            
            let url = getNodeApiUrl(`employeeAbsences?accountId=${accountId}&startDate=${startDate}&endDate=${endDate}`);

            // Filtro per dipendenti selezionati
            if (selectedEmployees && selectedEmployees.length > 0) {
                const employeeIds = selectedEmployees.map(emp => emp.value).join(',');
                url += `&userId=${employeeIds}`;
            }

            const token = localStorage.getItem('installamelo-auth-token');
            if (!token) {
                console.error('Token di autenticazione non disponibile');
                return [];
            }

            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': token
                }
            });

            if (response.data && response.data.success) {
                const absences = response.data.data;

                // Mapping icone Phosphor per tipo di assenza
                const absenceIconClasses = {
                    'ferie': 'ph-duotone ph-sun-horizon',
                    'malattia': 'ph-duotone ph-thermometer',
                    'permesso': 'ph-duotone ph-clipboard-text',
                    'infortunio': 'ph-duotone ph-first-aid-kit',
                    'maternità': 'ph-duotone ph-baby',
                    'paternità': 'ph-duotone ph-baby',
                    'lutto': 'ph-duotone ph-flower-lotus',
                    'congedo': 'ph-duotone ph-calendar-blank',
                    'aspettativa': 'ph-duotone ph-pause-circle',
                    'formazione': 'ph-duotone ph-graduation-cap',
                    'default': 'ph-duotone ph-user-minus'
                };
                
                // Trasforma le assenze in eventi per il calendario
                const absenceEvents = absences.map(absence => {
                    // Usa il colore dell'utente restituito dall'API
                    const eventColor = absence.userColor || '#7367f0';
                    
                    // Determina l'icona in base al tipo di assenza
                    const absenceTypeLower = (absence.absenceType || '').toLowerCase();
                    const iconClass = absenceIconClasses[absenceTypeLower] || absenceIconClasses['default'];
                    
                    // Calcola il colore del testo in base alla luminosità del colore di sfondo
                    const hexToRgb = (hex) => {
                        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
                        return result ? {
                            r: parseInt(result[1], 16),
                            g: parseInt(result[2], 16),
                            b: parseInt(result[3], 16)
                        } : { r: 0, g: 0, b: 0 };
                    };
                    const rgb = hexToRgb(eventColor);
                    const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
                    const textColor = luminance > 0.5 ? '#000000' : '#ffffff';

                    return {
                        id: 'absence-' + absence._id, // Aggiungiamo un prefisso per distinguere dalle commesse
                        title: `${absence.userLabel}: ${absence.absenceType.charAt(0).toUpperCase() + absence.absenceType.slice(1)}`,
                        start: absence.start,
                        end: absence.end,
                        allDay: false,
                        extendedProps: {
                            isAbsence: true, // Flag per identificare che è un'assenza
                            absenceId: absence._id,
                            userId: absence.userId,
                            userLabel: absence.userLabel,
                            absenceType: absence.absenceType,
                            absenceTypeId: absence.absenceTypeId,
                            notes: absence.notes,
                            approved: absence.approved,
                            userColor: eventColor,
                            iconClass: iconClass // Classe icona Phosphor
                        },
                        backgroundColor: eventColor,
                        borderColor: eventColor,
                        textColor: textColor,
                        // Forza la visualizzazione come evento a blocco (non dot)
                        display: 'block',
                        // Stile distintivo per le assenze
                        classNames: ['employee-absence']
                    };
                });

                return absenceEvents;
            } else {
                console.error('❌ Errore nel caricamento delle assenze:', response.data);
                return [];
            }
        } catch (error) {
            console.error('❌ Errore nella richiesta delle assenze:', error);
            return [];
        }
    }, [selectedEmployees, accountData]);

    // Aggiorna gli eventi del calendario quando le pianificazioni cambiano
    useEffect(() => {
        const styleId = 'employee-absence-styles';
        if (!document.getElementById(styleId)) {
            const style = document.createElement('style');
            style.id = styleId;
            style.innerHTML = `
                .employee-absence {
                    border-radius: 4px !important;
                    z-index: 999 !important;
                    position: relative !important;
                    pointer-events: auto !important;
                    display: block !important;
                    visibility: visible !important;
                    min-height: 25px !important;
                    font-weight: normal !important;
                }
                /* Forza la visualizzazione anche per i dot events */
                .employee-absence.fc-daygrid-dot-event {
                    display: block !important;
                    width: 100% !important;
                    height: auto !important;
                    min-height: 25px !important;
                }
                .employee-absence .fc-event-main,
                .employee-absence .fc-event-main-frame,
                .employee-absence .fc-event-title,
                .employee-absence .fc-event-time,
                .fc-event.employee-absence .fc-event-title,
                .fc-event.employee-absence .fc-event-time,
                .fc-daygrid-block-event.employee-absence .fc-event-title {
                    font-weight: 400 !important;
                    display: block !important;
                    visibility: visible !important;
                    text-shadow: none !important;
                }
                .employee-absence:hover {
                    opacity: 1 !important;
                    transform: scale(1.05) !important;
                    transition: all 0.2s ease;
                }
                .absence-panel-container .card {
                    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.2);
                }
                .absence-details-panel .card-header button.close:focus {
                    outline: none;
                    box-shadow: none;
                }
            `;
            document.head.appendChild(style);
        }
        return () => {
            const styleElem = document.getElementById(styleId);
            if (styleElem) styleElem.remove();
        };
    }, []);
    
    // Stili CSS per il calendario
    useEffect(() => {
        // Converti le pianificazioni in eventi FullCalendar
        const newEvents = [];

        plannings.forEach(planning => {
            const { job, jobLabel, dates, startTime, endTime, employees } = planning;
            // Usa jobLabel se disponibile, altrimenti torna alle proprietà di job
            const title = jobLabel || (job ? (job.title || job.name) : 'Commessa');

            // Crea un evento per ogni data nella pianificazione
            dates.forEach(date => {
                const dateObj = new Date(date);
                const startHour = parseInt(startTime.split(':')[0], 10);
                const startMinute = parseInt(startTime.split(':')[1], 10);
                const endHour = parseInt(endTime.split(':')[0], 10);
                const endMinute = parseInt(endTime.split(':')[1], 10);
                
                const eventStart = new Date(dateObj);
                eventStart.setHours(startHour, startMinute, 0);
                
                const eventEnd = new Date(dateObj);
                eventEnd.setHours(endHour, endMinute, 0);
                
                // Calcola il colore dell'evento in base al numero di dipendenti
                const colorIndex = employees.length % 5; // Cicla tra 5 colori
                const colorPalette = ['#7367f0', '#00cfe8', '#ea5455', '#28c76f', '#ff9f43'];
                
                newEvents.push({
                    id: `${planning.id}_${date}`, // ID unico per ogni evento
                    title: `${title} (${employees.length} dip.)`,
                    start: eventStart,
                    end: eventEnd,
                    color: colorPalette[colorIndex],
                    extendedProps: {
                        planningId: planning.id,
                        employees: employees.map(e => e.label || (e.firstName + ' ' + e.lastName)).join(', '),
                        vehicles: planning.vehicles.map(v => v.label || v.model || v.name).join(', '),
                        equipments: planning.equipments.map(e => e.label || e.name).join(', '),
                    }
                });
            });
        });
        
        // Aggiorna solo gli eventi nello stato, il rendering verrà gestito dall'useEffect che osserva [events]
        setEvents(newEvents);
    }, [plannings]); // Dipendenza dall'array di pianificazioni
    const calendarRef = useRef(null);
    const [activeView, setActiveView] = useState('dayGridMonth');
    
    // Stato per gestire il collasso della sidebar
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    
    // Riferimento all'API di FullCalendar
    const calendarApiRef = useRef(null);
    
    // Stato per tracciare se il calendario è stato inizializzato
    const [calendarInitialized, setCalendarInitialized] = useState(false);

    // Ottieni l'utente corrente e il token dallo stato di Redux
    const user = useSelector(state => state.auth?.user);
    const token = useSelector(state => state.auth?.token);

    // Funzione per ottenere l'URL base dell'API
    const getApiBaseUrl = () => {
        // Se disponibile da variabili d'ambiente, altrimenti usa il default
        return window.VITE_API_BASE_URL || '';
    };

    // Funzione per caricare l'elenco delle commesse
    const fetchJobs = async () => {
        try {
            // Usa dati di esempio se l'utente non è disponibile o per testing
            if (!user?.accountId) {
                // Dati di esempio per testing
                setJobs([
                    { id: '1', title: 'Manutenzione caldaia - Residence ABC' },
                    { id: '2', title: 'Riparazione condizionatore - Hotel XYZ' },
                    { id: '3', title: 'Installazione impianto - Condominio Verde' }
                ]);
                return;
            }
            
            const accountId = user.accountId;
            const token = localStorage.getItem('installamelo-auth-token');
            
            if (!token) {
                setJobs([
                    { id: '1', title: 'Manutenzione caldaia - Residence ABC' },
                    { id: '2', title: 'Riparazione condizionatore - Hotel XYZ' },
                    { id: '3', title: 'Installazione impianto - Condominio Verde' }
                ]);
                return;
            }
            
            const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/jobs/list?accountId=${accountId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': token
                }
            });
            
            if (response.ok) {
                const data = await response.json();
                setJobs(data);
            } else {
                toast.error('Errore nel caricamento delle commesse');
                // Dati di fallback
                setJobs([
                    { id: '1', title: 'Manutenzione caldaia - Residence ABC' },
                    { id: '2', title: 'Riparazione condizionatore - Hotel XYZ' },
                    { id: '3', title: 'Installazione impianto - Condominio Verde' }
                ]);
            }
        } catch (error) {
            console.error('Errore nel caricamento delle commesse:', error);
            toast.error('Errore di connessione');
            // Dati di fallback
            setJobs([
                { id: '1', title: 'Manutenzione caldaia - Residence ABC' },
                { id: '2', title: 'Riparazione condizionatore - Hotel XYZ' },
                { id: '3', title: 'Installazione impianto - Condominio Verde' }
            ]);
        }
    };

    // Funzione per caricare l'elenco dei clienti
    const fetchCustomers = async () => {
        try {
            // Verifica che sia disponibile l'ID dell'account
            if (!user?.accountId) {
                setCustomers([
                    { id: '1', name: 'Cliente ABC', fiscalCode: '12345678901' },
                    { id: '2', name: 'Azienda XYZ', fiscalCode: '98765432109' },
                    { id: '3', name: 'Condominio Verde', fiscalCode: '45678901234' }
                ]);
                return;
            }
            
            const accountId = user.accountId;
            const token = localStorage.getItem('installamelo-auth-token');
            
            if (!token) {
                setCustomers([
                    { id: '1', name: 'Cliente ABC', fiscalCode: '12345678901' },
                    { id: '2', name: 'Azienda XYZ', fiscalCode: '98765432109' },
                    { id: '3', name: 'Condominio Verde', fiscalCode: '45678901234' }
                ]);
                return;
            }
            
            // Utilizziamo l'endpoint getForSelect2 come nel componente CustomerSelect
            const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/customers/getForSelect2?accountId=${accountId}&searchTerm=&page=0&pagination=50`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': token
                }
            });
            
            if (response.ok) {
                const data = await response.json();
                // Trasformiamo i dati nel formato corretto per il componente
                const formattedCustomers = data.results?.map(item => ({
                    id: item.id,
                    _id: item.id,
                    name: item.text,
                    businessName: item.text
                })) || [];
                setCustomers(formattedCustomers);
                
                // Se non ci sono clienti, mostra un toast informativo
                if (!formattedCustomers || formattedCustomers.length === 0) {
                    toast.info('Nessun cliente disponibile');
                }
            } else {
                const errorText = await response.text();
                console.error('Errore API clienti:', errorText);
                toast.error(`Errore nel caricamento dei clienti: ${response.status}`);
                setCustomers([]);
            }
        } catch (error) {
            console.error('Errore nel caricamento dei clienti:', error);
            toast.error('Errore di connessione al server');
            setCustomers([]);
        }
    };

    // Funzioni per caricare le risorse
    const fetchEmployees = useCallback(async () => {
        setIsLoadingResources(true);
        try {
            // Ottieni l'ID dell'account
            if (!user?.accountId) {
                // Dati di esempio se non c'è un accountId disponibile
                setEmployees([
                    { id: '1', firstName: 'Mario', lastName: 'Rossi', role: 'Tecnico' },
                    { id: '2', firstName: 'Giuseppe', lastName: 'Verdi', role: 'Installatore' },
                    { id: '3', firstName: 'Anna', lastName: 'Bianchi', role: 'Amministrazione' }
                ]);
                return;
            }
            
            const accountId = user.accountId;
            const token = localStorage.getItem('installamelo-auth-token');
            
            if (!token) {
                setEmployees([
                    { id: '1', firstName: 'Mario', lastName: 'Rossi', role: 'Tecnico' },
                    { id: '2', firstName: 'Giuseppe', lastName: 'Verdi', role: 'Installatore' },
                    { id: '3', firstName: 'Anna', lastName: 'Bianchi', role: 'Amministrazione' }
                ]);
                return;
            }
            
            // Effettua la chiamata API
            const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/users/getEmployeesList?accountId=${accountId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': token
                }
            });
            
            if (response.ok) {
                const data = await response.json();
                setEmployees(data);
                
                // Se non ci sono dipendenti, mostra un toast informativo
                if (!data || data.length === 0) {
                    toast.info('Nessun dipendente disponibile');
                }
            } else {
                const errorText = await response.text();
                console.error('Errore API dipendenti:', errorText);
                toast.error(`Errore nel caricamento dei dipendenti: ${response.status}`);
                setEmployees([]);
            }
        } catch (error) {
            console.error('Errore nel caricamento dei dipendenti:', error);
            toast.error('Errore di connessione al server');
            setEmployees([]);
        } finally {
            setIsLoadingResources(false);
        }
    }, [user]);

    const fetchVehicles = async () => {
        setIsLoadingResources(true);
        try {
            // Usa dati di esempio se l'utente non è disponibile o per testing
            if (!user?.accountId) {
                // Dati di esempio per testing
                const mockVehicles = [
                    { id: '1', name: 'Furgone', model: 'Furgone', plateNumber: 'AB123CD' },
                    { id: '2', name: 'Auto aziendale', model: 'Auto aziendale', plateNumber: 'XY456ZW' },
                    { id: '3', name: 'Furgone grande', model: 'Furgone grande', plateNumber: 'EF789GH' }
                ];
                setVehicles(mockVehicles);
                return;
            }
            
            const accountId = user.accountId;
            const token = localStorage.getItem('installamelo-auth-token');
            
            if (!token) {
                const mockVehicles = [
                    { id: '1', name: 'Furgone', model: 'Furgone', plateNumber: 'AB123CD' },
                    { id: '2', name: 'Auto aziendale', model: 'Auto aziendale', plateNumber: 'XY456ZW' },
                    { id: '3', name: 'Furgone grande', model: 'Furgone grande', plateNumber: 'EF789GH' }
                ];
                setVehicles(mockVehicles);
                return;
            }
            
            const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/vehicles/list?accountId=${accountId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': token
                }
            });
            
            if (response.ok) {
                const data = await response.json();
                setVehicles(data);
            } else {
                toast.error('Errore nel caricamento dei veicoli');
            }
        } catch (error) {
            console.error('Errore nel caricamento dei veicoli:', error);
            // Carica dati di fallback in caso di errore
            setVehicles([
                { id: '1', name: 'Furgone', model: 'Furgone', plateNumber: 'AB123CD' },
                { id: '2', name: 'Auto aziendale', model: 'Auto aziendale', plateNumber: 'XY456ZW' },
                { id: '3', name: 'Furgone grande', model: 'Furgone grande', plateNumber: 'EF789GH' }
            ]);
        } finally {
            setIsLoadingResources(false);
        }
    };

    const fetchEquipments = async () => {
        setIsLoadingResources(true);
        try {
            // Usa dati di esempio se l'utente non è disponibile o per testing
            if (!user?.accountId) {
                // Dati di esempio per testing
                const mockEquipments = [
                    { id: '1', name: 'Trapano professionale' },
                    { id: '2', name: 'Kit idraulico' },
                    { id: '3', name: 'Scala telescopica' },
                    { id: '4', name: 'Generatore' }
                ];
                setEquipments(mockEquipments);
                return;
            }
            
            const accountId = user.accountId;
            const token = localStorage.getItem('installamelo-auth-token');
            
            if (!token) {
                const mockEquipments = [
                    { id: '1', name: 'Trapano professionale' },
                    { id: '2', name: 'Kit idraulico' },
                    { id: '3', name: 'Scala telescopica' },
                    { id: '4', name: 'Generatore' }
                ];
                setEquipments(mockEquipments);
                return;
            }
            
            const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/equipments/list?accountId=${accountId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': token
                }
            });
            if (response.ok) {
                const data = await response.json();
                setEquipments(data);
            } else {
                toast.error('Errore nel caricamento delle attrezzature');
            }
        } catch (error) {
            console.error('Errore nel caricamento delle attrezzature:', error);
            // Carica dati di fallback in caso di errore
            setEquipments([
                { id: '1', name: 'Trapano professionale' },
                { id: '2', name: 'Kit idraulico' },
                { id: '3', name: 'Scala telescopica' },
                { id: '4', name: 'Generatore' }
            ]);
        } finally {
            setIsLoadingResources(false);
        }
    };

    // Funzione per aggiungere una pianificazione
    const addPlanning = () => {
        if (!selectedJob) {
            toast.warning('Seleziona una commessa');
            return;
        }
        
        // Ottieni l'oggetto commessa effettivo dai dati react-select
        const jobData = selectedJob.data;

        if (!startDate || !endDate) {
            toast.warning('Seleziona data di inizio e fine');
            return;
        }
        
        // Verifica che la data di inizio sia minore o uguale alla data di fine
        if (startDate > endDate) {
            toast.warning('La data di inizio deve essere precedente o uguale alla data di fine');
            return;
        }

        if (!startTime || !endTime) {
            toast.warning('Seleziona orario di inizio e fine');
            return;
        }

        // Genera un array di date tra startDate e endDate
        const dateArray = [];
        let currentDate = new Date(startDate);
        const lastDate = new Date(endDate);
        
        // Includi sia la data di inizio che quella di fine
        while (currentDate <= lastDate) {
            dateArray.push(currentDate.toISOString().split('T')[0]);
            currentDate.setDate(currentDate.getDate() + 1);
        }

        const newPlanning = {
            id: Date.now(),
            job: selectedJob.data,  // Usa i dati effettivi della commessa
            jobLabel: selectedJob.label, // Salva anche l'etichetta per la visualizzazione
            dates: dateArray,
            startDate: startDate,
            endDate: endDate,
            startTime,
            endTime,
            notes: planningNotes,
            employees: [...selectedEmployees],
            vehicles: [...selectedVehicles],
            equipments: [...selectedEquipments]
        };

        setPlannings([...plannings, newPlanning]);
        
        // Reset della selezione ma mantiene la commessa e le date
        setSelectedEmployees([]);
        setSelectedVehicles([]);
        setSelectedEquipments([]);
        setPlanningNotes('');
        
        toast.success('Pianificazione aggiunta');
    };

    // Funzione per eliminare una pianificazione
    const removePlanning = (id) => {
        setPlannings(plannings.filter(plan => plan.id !== id));
        toast.info('Pianificazione rimossa');
    };

    // Funzione per salvare tutte le pianificazioni
    const savePlannings = async () => {
        if (plannings.length === 0) {
            toast.warning('Nessuna pianificazione da salvare');
            return;
        }

        try {
            // TODO: Implementare la chiamata API per salvare le pianificazioni
            // const response = await fetch('/api/plannings/save', {
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/json'
            //     },
            //     body: JSON.stringify({ plannings })
            // });
            
            // Simulazione salvataggio (da rimuovere in produzione)
            toast.success('Pianificazioni salvate con successo');
            setPlannings([]);
            setSidebarCollapsed(true);
        } catch (error) {
            console.error('Errore nel salvare le pianificazioni:', error);
            toast.error('Errore nel salvare le pianificazioni');
        }
    };

    useEffect(() => {
        fetchJobs();
        // Carica i dipendenti e i clienti all'avvio
        fetchEmployees();
        fetchCustomers();
    }, []);

    useEffect(() => {
        if (!sidebarCollapsed) {
            // Carica sempre veicoli e attrezzature quando la sidebar è aperta
            fetchVehicles();
            fetchEquipments();
        }
    }, [sidebarCollapsed]);

    // Funzione per ridimensionare il calendario
    const resizeCalendar = () => {
        if (calendarApiRef.current) {
            calendarApiRef.current.updateSize();
        }
    };

    // Listener per il ridimensionamento della finestra
    useEffect(() => {
        window.addEventListener('resize', resizeCalendar);
        
        // Cleanup listener
        return () => {
            window.removeEventListener('resize', resizeCalendar);
        };
    }, []);

    // Aggiungi listener per la fine delle transizioni (sidebar)
    useEffect(() => {
        const mainContentElement = document.getElementById('main-calendar-content');
        if (mainContentElement) {
            const handleTransitionEnd = () => {
                resizeCalendar();
            };
            
            mainContentElement.addEventListener('transitionend', handleTransitionEnd);
            
            return () => {
                mainContentElement.removeEventListener('transitionend', handleTransitionEnd);
            };
        }
    }, []);

    // Ridimensiona il calendario quando lo stato della sidebar cambia
    useEffect(() => {
        // Piccolo ritardo per permettere alla transizione di iniziare
        setTimeout(resizeCalendar, 50);
        // Un altro ridimensionamento alla fine della transizione
        setTimeout(resizeCalendar, 350); // Tempo approssimativo della transizione CSS
    }, [sidebarCollapsed]);
    
    // Inseriamo lo stile per i gradienti all'avvio del componente
    useEffect(() => {
        // Inseriamo lo stile CSS necessario per i gradienti
        const removeStyle = insertGradientStyle();
        
        // Cleanup quando il componente viene smontato
        return () => {
            removeStyle();
        };
    }, []);
    
    useEffect(() => {
        // Non inizializzare il calendario se l'account non è disponibile
        if (!accountData || !accountData._id) {
            return;
        }
        
        // Funzione per importare dinamicamente le librerie di FullCalendar
        const loadCalendarLibraries = async () => {
            try {
                // Importa dinamicamente le librerie di FullCalendar
                const [
                    { Calendar },
                    { default: itLocale },
                    { default: dayGridPlugin },
                    { default: timeGridPlugin },
                    { default: listPlugin },
                    { default: interactionPlugin }
                ] = await Promise.all([
                    import('@fullcalendar/core'),
                    import('@fullcalendar/core/locales/it'),
                    import('@fullcalendar/daygrid'),
                    import('@fullcalendar/timegrid'),
                    import('@fullcalendar/list'),
                    import('@fullcalendar/interaction')
                ]);

                // Verifica che il container esista ancora (potrebbe essere smontato)
                if (!calendarRef.current) return;

                // Inizializza FullCalendar
                const calendar = new Calendar(calendarRef.current, {
                    plugins: [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
                    locale: itLocale,
                    height: 'auto', // Permette al calendario di adattarsi all'altezza del contenitore
                    headerToolbar: {
                        left: 'prev,next today',
                        center: 'title',
                        right: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth'
                    },
                    buttonText: {
                        today: 'Oggi',
                        month: 'Mese',
                        week: 'Settimana',
                        day: 'Giorno',
                        list: 'Lista'
                    },
                    initialView: 'dayGridMonth',
                    // Configurazioni specifiche per le diverse viste
                    dayMaxEvents: false, // Mostra tutti gli eventi senza limiti (niente pulsante +altro)
                    slotEventOverlap: false, // Impedisce la sovrapposizione degli eventi nelle viste a griglia
                    slotDuration: '00:30:00', // Durata di ogni slot nelle viste a griglia (30 minuti)
                    slotMinTime: '07:00:00', // Ora di inizio della giornata nelle viste
                    slotMaxTime: '20:00:00', // Ora di fine della giornata nelle viste
                    views: {
                        dayGridMonth: {
                            // Forza la visualizzazione a blocco nella vista mensile
                            eventDisplay: 'block',
                            displayEventEnd: true,
                            dayMaxEvents: false, // Mostra tutti gli eventi senza limite
                            dayMaxEventRows: false, // Disabilita anche il limite di righe di eventi
                            // Non mostrare l'orario nel titolo degli eventi
                            displayEventTime: false,
                            eventTimeFormat: {
                                hour: '2-digit',
                                minute: '2-digit',
                                meridiem: false
                            }
                        },
                        timeGridWeek: {
                            // Configurazione specifica per la vista settimanale
                            allDaySlot: true,        // Mostra lo slot "tutto il giorno", importante per gli eventi che non hanno orario specifico
                            slotEventOverlap: false, // Non sovrapporre gli eventi
                            nowIndicator: true,      // Mostra indicatore dell'ora corrente
                            slotLabelFormat: {
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: false
                            },
                            // Assicurati che gli eventi siano realmente visualizzati
                            displayEventTime: true,
                            displayEventEnd: true,
                            eventMinHeight: 25,      // Altezza minima evento
                            // Stili aggiuntivi per la vista settimanale
                            eventTimeFormat: {
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: false
                            }
                        },
                        timeGridDay: {
                            // Configurazione specifica per la vista giornaliera
                            allDaySlot: true,        // Mostra lo slot "tutto il giorno", importante per gli eventi che non hanno orario specifico
                            slotEventOverlap: false, // Non sovrapporre gli eventi
                            nowIndicator: true,      // Mostra indicatore dell'ora corrente
                            slotLabelFormat: {
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: false
                            },
                            // Assicurati che gli eventi siano realmente visualizzati
                            displayEventTime: true,
                            displayEventEnd: true,
                            eventMinHeight: 25,      // Altezza minima evento
                            // Stili aggiuntivi per la vista giornaliera
                            eventTimeFormat: {
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: false
                            }
                        }
                    },
                    editable: true,
                    eventResizableFromStart: true, // Permette resize anche dall'inizio
                    selectable: true,
                    selectMirror: true,
                    weekNumbers: true,
                    navLinks: true,
                    nowIndicator: true,
                    // Rimuoviamo l'indicazione dell'orario dal titolo degli eventi
                    displayEventTime: false,
                    displayEventEnd: false,
                    eventTimeFormat: {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false
                    },
                    // Listener per i cambi di visualizzazione
                    datesSet: function(info) {
                    },
                    
                    // Usiamo direttamente la funzione per ottenere gli eventi API quando il calendario lo richiede
                    events: function(info, successCallback, failureCallback) {
                        
                        // Verifica che accountId sia disponibile
                        const accountId = accountData?._id;
                        if (!accountId) {
                            console.warn('ID account non ancora disponibile, verranno mostrati eventi vuoti temporaneamente');
                            // Restituisci un array vuoto invece di causare un errore
                            // Questo permette al calendario di renderizzarsi correttamente
                            // e gli eventi verranno caricati quando accountData sarà disponibile
                            successCallback([]);
                            return;
                        }
                        
                        // Flag per tenere traccia delle chiamate completate
                        let appointmentsLoaded = false;
                        let absencesLoaded = false;
                        let allEvents = [];
                        
                        // Funzione per combinare i risultati e chiamare successCallback quando entrambe le chiamate sono complete
                        const checkAndCombineResults = () => {
                            if (appointmentsLoaded && absencesLoaded) {
                                successCallback(allEvents);
                            }
                        };
                        
                        // Verifica che info.view esista prima di accedervi
                        const viewType = info.view ? info.view.type : 'non disponibile';
                        
                        // Assicuriamoci di avere un intervallo di date ampio per coprire tutte le viste
                        // In questo modo risolviamo il problema degli eventi che spariscono al cambio vista
                        let fromDateObj, toDateObj;
                        
                        // Usa date diverse in base alla vista per garantire che tutti gli eventi siano visibili
                        if (viewType === 'dayGridMonth') {
                            // Per la vista mensile, usa l'intervallo fornito
                            fromDateObj = new Date(info.startStr);
                            toDateObj = new Date(info.endStr);
                        } else {
                            // Per le viste settimanale/giornaliera, amplia l'intervallo 
                            // per includere almeno un mese intero
                            fromDateObj = new Date(info.startStr);
                            toDateObj = new Date(info.endStr);
                            
                            // Assicurati che l'intervallo sia di almeno 30 giorni
                            const daysDiff = (toDateObj - fromDateObj) / (1000 * 60 * 60 * 24);
                            if (daysDiff < 30) {
                                // Estendi il periodo di fine di altri giorni per arrivare a 30
                                const daysToAdd = 30 - daysDiff;
                                toDateObj.setDate(toDateObj.getDate() + daysToAdd);
                            }
                        }
                        
                        // Standardizza le ore per consistenza
                        fromDateObj.setHours(0, 0, 0, 0);
                        toDateObj.setHours(23, 59, 59, 999);
                        
                        const fromDateStr = fromDateObj.toISOString();
                        const toDateStr = toDateObj.toISOString();
                        
                        // Prepara i parametri di base
                        const params = {
                            accountId: accountData._id,
                            fromDate: fromDateStr,
                            toDate: toDateStr
                        };
                        
                        // Ottieni il cliente dalla variabile globale o dallo stato locale
                        const effectiveCustomer = window.selectedCalendarCustomer || selectedCustomer;
                        
                        if (effectiveCustomer) {
                            // Estrai l'ID cliente da qualsiasi formato possibile
                            const customerId = 
                                effectiveCustomer.value || 
                                effectiveCustomer.id || 
                                effectiveCustomer._id || 
                                effectiveCustomer.data?.id;
                                
                            if (customerId) {
                                params.customerId = customerId;
                            }
                        }
                        
                        // Ottieni i dipendenti dalla variabile globale o dallo stato locale
                        const effectiveEmployees = window.selectedCalendarEmployees || selectedEmployees;
                        
                        // Aggiungi filtro dipendenti se selezionati
                        if (effectiveEmployees && effectiveEmployees.length > 0) {
                            params.employeeIds = effectiveEmployees.map(user => user.value || user.id).join(',');
                        }
                        
                        // Converti in URLSearchParams per assicurarsi che i parametri vengano codificati correttamente
                        const urlParams = new URLSearchParams();
                        for (const key in params) {
                            if (params[key] !== undefined && params[key] !== null) {
                                urlParams.append(key, params[key]);
                            }
                        }
                        
                        // Usa apiGet che gestisce automaticamente base URL e autenticazione
                        // Passa tutti i parametri inclusi customerId e employeeIds
                        const apiParams = {};
                        for (const [key, value] of urlParams.entries()) {
                            apiParams[key] = value;
                        }
                        
                        apiGet(`appointments/bydate`, apiParams)
                        .then(response => {
                            
                            // Trasforma i dati per FullCalendar
                            if (response.data && Array.isArray(response.data)) {
                                // Date degli appuntamenti elaborate in formato per il calendario
                                    
                                const calendarEvents = response.data.map(appointment => {
                                    // Gestione dei colori degli utenti
                                    let backgroundColor = '#7367f0'; // Colore predefinito
                                    let backgroundImage = '';
                                    
                                    // Controlla se ci sono utenti assegnati all'appuntamento
                                    if (appointment.users && appointment.users.length > 0) {
                                        // Verifica che gli utenti abbiano colori validi
                                        const usersWithColors = appointment.users.filter(user => 
                                            user.userColor && user.userColor !== '' && user.userColor !== 'undefined');
                                        
                                        // Se c'è un solo utente con colore, usa quel colore
                                        if (usersWithColors.length === 1) {
                                            backgroundColor = usersWithColors[0].userColor;
                                        } 
                                        // Se ci sono più utenti con colore, crea un effetto sfumato
                                        else if (usersWithColors.length > 1) {
                                            // Raccogli i colori degli utenti
                                            const userColors = usersWithColors.map(user => user.userColor);
                                            
                                            // Limita a massimo 3 colori per l'effetto sfumato
                                            const colorsToUse = userColors.slice(0, 3);
                                            
                                            // Crea un gradiente lineare con i colori
                                            if (colorsToUse.length === 2) {
                                                backgroundImage = `linear-gradient(to right, ${colorsToUse[0]}, ${colorsToUse[1]})`;
                                                backgroundColor = 'transparent'; // Rende trasparente il colore di sfondo per mostrare il gradiente
                                            } else if (colorsToUse.length >= 3) {
                                                backgroundImage = `linear-gradient(to right, ${colorsToUse[0]}, ${colorsToUse[1]}, ${colorsToUse[2]})`;
                                                backgroundColor = 'transparent'; // Rende trasparente il colore di sfondo per mostrare il gradiente
                                            }

                                        } else {
                                            // Se ci sono utenti ma nessuno ha un colore, usa il colore predefinito
                                            backgroundColor = '#7367f0';

                                        }
                                    }
                                    
                                    // Crea la descrizione da mostrare al passaggio del mouse
                                    let description = '';
                                    if (appointment.jobCode) description += `Commessa: ${appointment.jobCode}<br>`;
                                    if (appointment.jobTypeLabel) description += `Tipo: ${appointment.jobTypeLabel}<br>`;
                                    if (appointment.systemLabel) description += `Impianto: ${appointment.systemLabel}<br>`;
                                    if (appointment.systemAddressLabel) description += `Indirizzo: ${appointment.systemAddressLabel}<br>`;
                                    if (appointment.notes) description += `Note: ${appointment.notes}<br>`;
                                    
                                    // Aggiungi informazioni sulle risorse
                                    if (appointment.users && appointment.users.length > 0) {
                                        description += 'Risorse: ' + appointment.users.map(user => user.userLabel).join(', ');
                                    }
                                    
                                        // Definiamo classi CSS per l'evento
                                    const classes = [];
                                    
                                    // Verifichiamo se l'evento ha utenti assegnati
                                    if (!appointment.users || appointment.users.length === 0) {
                                        classes.push('no-users');
                                        backgroundColor = '#cccccc'; // Grigio per eventi senza utenti
                                    }
                                    
                                    // Conversione e validazione date
                                    const startDate = new Date(appointment.fromDate);
                                    const endDate = new Date(appointment.toDate);
                                    const startISO = startDate.toISOString();
                                    const endISO = endDate.toISOString();
                                    
                                    // Verifica date valide
                                    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
                                        // Silently ignore invalid dates
                                    }
                                    
                                    // Formatta orario nel formato HH:mm-HH:mm
                                    const formatTime = (date) => {
                                        const hours = date.getHours().toString().padStart(2, '0');
                                        const minutes = date.getMinutes().toString().padStart(2, '0');
                                        return `${hours}:${minutes}`;
                                    };
                                    const timeRange = `${formatTime(startDate)}-${formatTime(endDate)}`;
                                    
                                    // Costruisci il titolo con orario prima del codice commessa
                                    const eventTitle = `${timeRange} ${appointment.title}`;
                                    
                                    // BASE DELL'EVENTO - proprietà comuni
                                    const eventObj = {
                                        id: appointment._id,
                                        title: eventTitle,
                                        start: startISO,
                                        end: endISO,
                                        allDay: false,
                                        textColor: '#ffffff'
                                    };
                                    
                                    // LOGICA DI COLORAZIONE
                                    // 1. Eventi con utenti multipli (massimo 3) -> gradiente
                                    if (appointment.users && appointment.users.length > 1) {
                                        // Filtra solo utenti con colore valido
                                        const usersWithColors = appointment.users.filter(user => 
                                            user.userColor && user.userColor !== '' && user.userColor !== 'undefined');
                                            
                                        if (usersWithColors.length > 1) {
                                            // Raccogli i colori degli utenti (massimo 3)
                                            const userColors = usersWithColors.slice(0, 3).map(user => user.userColor);
                                            const gradient = userColors.length === 2 
                                                ? `linear-gradient(to right, ${userColors[0]}, ${userColors[1]})` 
                                                : `linear-gradient(to right, ${userColors[0]}, ${userColors[1]}, ${userColors[2]})`;
                                                
                                            // Aggiungi classe per il gradiente
                                            classes.push('gradient-event');
                                            
                                            // Imposta proprietà per il gradiente
                                            eventObj.extendedProps = {
                                                ...eventObj.extendedProps,
                                                gradientStyle: gradient,
                                                description: description,
                                                appointment: appointment
                                            };
                                            
                                            // Imposta stile CSS custom
                                            eventObj.classNames = classes;
                                        } else {
                                            // Fallback se non ci sono abbastanza utenti con colori validi
                                            eventObj.backgroundColor = backgroundColor;
                                            eventObj.borderColor = backgroundColor;
                                            eventObj.classNames = classes;
                                            eventObj.extendedProps = {
                                                description: description,
                                                appointment: appointment
                                            };
                                        }
                                    } 
                                    // 2. Evento con un solo utente -> colore solido
                                    else if (appointment.users && appointment.users.length === 1 && appointment.users[0].userColor) {
                                        // Usa il colore dell'unico utente
                                        const userColor = appointment.users[0].userColor;
                                        eventObj.backgroundColor = userColor;
                                        eventObj.borderColor = userColor;
                                        eventObj.classNames = classes;
                                        
                                        // Imposta variabile CSS personalizzata per il colore
                                        eventObj.style = `--event-color: ${userColor}`;
                                        
                                        eventObj.extendedProps = {
                                            description: description,
                                            appointment: appointment
                                        };
                                    }
                                    // 3. Evento senza utenti o con utenti senza colore -> colore default
                                    else {
                                        eventObj.backgroundColor = backgroundColor;
                                        eventObj.borderColor = backgroundColor;
                                        eventObj.classNames = classes;
                                        
                                        // Imposta variabile CSS personalizzata per il colore
                                        eventObj.style = `--event-color: ${backgroundColor}`;
                                        
                                        eventObj.extendedProps = {
                                            description: description,
                                            appointment: appointment
                                        };
                                    }
                                    
                                    // Se abbiamo un gradiente, impostiamo le proprietà correlate
                                    if (backgroundImage) {

                                        eventObj.classNames.push('gradient-background');
                                        eventObj.extendedProps.gradientStyle = backgroundImage;
                                        // Resettiamo il backgroundColor per usare il gradiente
                                        eventObj.backgroundColor = 'transparent';
                                    } else {

                                    }
                                    
                                    return eventObj;
                                });
                                

                                // Aggiungi gli eventi appuntamenti (non sovrascrivere!)
                                allEvents = [...allEvents, ...calendarEvents];
                                appointmentsLoaded = true;
                                
                                // Verifica se tutte le chiamate sono state completate
                                checkAndCombineResults();
                            } else {
                                console.error('❌ Dati API non validi o array vuoto');
                                appointmentsLoaded = true;
                                checkAndCombineResults();
                            }
                        })
                        .catch(error => {
                            console.error('❌ Errore API appuntamenti:', error);
                            appointmentsLoaded = true;
                            checkAndCombineResults();
                        });
                        
                        // Carica anche le assenze dei collaboratori
                        // Passiamo date complete per assicurarci che le assenze vengano trovate
                        // L'inizio della giornata per la data di inizio
                        const fromDateWithTime = new Date(fromDateStr);
                        fromDateWithTime.setHours(0, 0, 0, 0);
                        
                        // La fine della giornata per la data di fine
                        const toDateWithTime = new Date(toDateStr);
                        toDateWithTime.setHours(23, 59, 59, 999);
                        
                        const formattedFromDate = fromDateWithTime.toISOString();
                        const formattedToDate = toDateWithTime.toISOString();
                        
                        fetchEmployeeAbsences(formattedFromDate, formattedToDate)
                            .then(absenceEvents => {
                                // Aggiungi le assenze agli eventi
                                allEvents = [...allEvents, ...absenceEvents];
                                absencesLoaded = true;
                                
                                // Verifica se tutte le chiamate sono state completate
                                checkAndCombineResults();
                            })
                            .catch(error => {
                                console.error('❌ Errore caricamento assenze:', error);
                                absencesLoaded = true;
                                checkAndCombineResults();
                            });
                    },
                    eventDidMount: function(info) {
                        // Aggiungi tooltip nativo quando passi il mouse sull'evento
                        if (info.event.extendedProps) {
                            // Prepariamo il contenuto del tooltip
                            let tooltipContent = '';
                            
                            // Per le assenze, creiamo un tooltip specifico (senza badge stato)
                            if (info.event.extendedProps.isAbsence) {
                                const absence = info.event.extendedProps;
                                tooltipContent += `Assenza: ${absence.absenceType}\n`;
                                tooltipContent += `Dipendente: ${absence.userLabel}`;
                                if (absence.notes) tooltipContent += `\nNote: ${absence.notes}`;
                            }
                            // Per gli appuntamenti, usiamo il tooltip standard
                            else {
                                // Aggiungiamo in evidenza il tipo di commessa se disponibile
                                if (info.event.extendedProps.jobTypeLabel) {
                                    tooltipContent += `Tipo: ${info.event.extendedProps.jobTypeLabel}\n\n`;
                                }
                                
                                // Aggiungiamo il resto della descrizione
                                if (info.event.extendedProps.description) {
                                    tooltipContent += info.event.extendedProps.description.replace(/<br>/g, '\n');
                                }
                            }
                            
                            // Impostiamo il tooltip
                            if (tooltipContent) {
                                info.el.title = tooltipContent;
                                info.el.classList.add('has-tooltip');
                            }
                        }
                        
                        // Verifica che info.view esista prima di accedervi
                        const viewType = info.view ? info.view.type : 'non disponibile';
                        
                        // Gestione specifica per le assenze
                        if (info.event.extendedProps && info.event.extendedProps.isAbsence) {
                            // Usa il colore dell'utente salvato nell'evento
                            const userColor = info.event.extendedProps.userColor || info.event.backgroundColor || '#7367f0';
                            const textColor = info.event.textColor || '#ffffff';
                            const iconClass = info.event.extendedProps.iconClass || 'ph-duotone ph-user-minus';
                            
                            // Assicuriamoci che la classe sia applicata
                            info.el.classList.add('employee-absence');
                            
                            // Inserisci l'icona Phosphor prima del titolo
                            const titleEl = info.el.querySelector('.fc-event-title');
                            if (titleEl && !titleEl.querySelector('.absence-icon')) {
                                const iconEl = document.createElement('i');
                                iconEl.className = `${iconClass} absence-icon`;
                                iconEl.style.marginRight = '5px';
                                iconEl.style.fontSize = '14px';
                                titleEl.insertBefore(iconEl, titleEl.firstChild);
                            }
                            
                            // Funzione per convertire hex in rgba con trasparenza
                            const hexToRgba = (hex, alpha) => {
                                const r = parseInt(hex.slice(1, 3), 16);
                                const g = parseInt(hex.slice(3, 5), 16);
                                const b = parseInt(hex.slice(5, 7), 16);
                                return `rgba(${r}, ${g}, ${b}, ${alpha})`;
                            };
                            
                            // Stili forzati sull'elemento principale con il colore dell'utente (sfondo con trasparenza)
                            const bgColorWithAlpha = hexToRgba(userColor, 0.7);
                            info.el.style.setProperty('background-color', bgColorWithAlpha, 'important');
                            info.el.style.setProperty('border-color', userColor, 'important');
                            info.el.style.setProperty('color', textColor, 'important');
                            info.el.style.setProperty('display', 'block', 'important');
                            info.el.style.setProperty('visibility', 'visible', 'important');
                            // Opacity applicata solo allo sfondo tramite rgba, non all'intero elemento
                            info.el.style.setProperty('z-index', '999', 'important');
                            info.el.style.setProperty('position', 'relative', 'important');
                            info.el.style.setProperty('min-height', '20px', 'important');
                            info.el.style.setProperty('border', `2px solid ${userColor}`, 'important');
                            info.el.style.setProperty('cursor', 'default', 'important'); // Assenze non cliccabili
                            
                            // Applica colore a tutti i contenitori rilevanti
                            const containers = [
                                info.el,                                        // Contenitore principale
                                info.el.querySelector('.fc-event-main'),       // Vista mensile
                                info.el.querySelector('.fc-event-main-frame'), // Vista settimanale
                                info.el.querySelector('.fc-event-title'),      // Titolo evento
                                info.el.querySelector('.fc-event-time')        // Orario evento
                            ];
                            
                            containers.forEach((container) => {
                                if (container) {
                                    container.style.setProperty('color', textColor, 'important');
                                    container.style.setProperty('font-weight', 'normal', 'important');
                                    container.style.setProperty('display', 'block', 'important');
                                    container.style.setProperty('visibility', 'visible', 'important');
                                    container.style.setProperty('opacity', '1', 'important');
                                }
                            });
                            
                            
                            return; // Termina qui per le assenze
                        }
                        
                        // LOGICA PER GLI APPUNTAMENTI (NON ASSENZE)
                        // 1. Eventi con più utenti -> gradienti
                        if (info.event.extendedProps.gradientStyle) {
                            const gradient = info.event.extendedProps.gradientStyle;
                            
                            // Imposta variabile CSS personalizzata
                            info.el.style.setProperty('--gradient-bg', gradient);
                            
                            // Aggiungi classe per il gradiente
                            info.el.classList.add('gradient-event');
                            
                            // Applica il gradiente direttamente a tutti i contenitori rilevanti
                            const containers = [
                                info.el,                                        // Contenitore principale
                                info.el.querySelector('.fc-event-main'),       // Vista mensile
                                info.el.querySelector('.fc-event-main-frame'), // Vista settimanale
                                info.el.querySelector('.fc-event-title'),      // Titolo evento
                                info.el.querySelector('.fc-event-time')        // Orario evento
                            ];
                            
                            containers.forEach(container => {
                                if (container) {
                                    container.style.backgroundImage = gradient;
                                    container.style.backgroundColor = 'transparent';
                                    container.style.color = '#fff';
                                }
                            });
                            
                            // Forza visibilità in vista settimanale/giornaliera
                            if (viewType.includes('timeGrid')) {
                                info.el.style.borderColor = '#666';
                                info.el.style.zIndex = '10';
                            }
                        }
                        // 2. Eventi con un solo utente -> colore solido
                        else {
                            // Ottieni il colore dell'evento (utente singolo o default)
                            const color = info.event.backgroundColor || '#7367f0';
                            
                            // Imposta variabile CSS personalizzata
                            info.el.style.setProperty('--event-color', color);
                            
                            // Applica colore di sfondo a tutti i contenitori rilevanti
                            const containers = [
                                info.el,                                        // Contenitore principale
                                info.el.querySelector('.fc-event-main'),       // Vista mensile
                                info.el.querySelector('.fc-event-main-frame'), // Vista settimanale
                                info.el.querySelector('.fc-event-title'),      // Titolo evento
                                info.el.querySelector('.fc-event-time')        // Orario evento
                            ];
                            
                            containers.forEach(container => {
                                if (container) {
                                    container.style.backgroundColor = color;
                                    container.style.color = '#fff';
                                }
                            });
                        }
                    },
                    eventClick: function(info) {
                        // Previeni il comportamento di default
                        info.jsEvent.preventDefault();
                        info.jsEvent.stopPropagation();
                        
                        // Ottieni l'evento cliccato
                        const clickedEvent = info.event;
                        
                        // Gestione click su assenza - apri modale dettagli
                        if (clickedEvent.extendedProps && clickedEvent.extendedProps.isAbsence) {
                            const absenceData = {
                                absenceId: clickedEvent.extendedProps.absenceId,
                                userId: clickedEvent.extendedProps.userId,
                                userLabel: clickedEvent.extendedProps.userLabel,
                                absenceType: clickedEvent.extendedProps.absenceType,
                                absenceTypeId: clickedEvent.extendedProps.absenceTypeId,
                                notes: clickedEvent.extendedProps.notes,
                                approved: clickedEvent.extendedProps.approved,
                                userColor: clickedEvent.extendedProps.userColor,
                                start: clickedEvent.start,
                                end: clickedEvent.end,
                                backgroundColor: clickedEvent.backgroundColor
                            };
                            setAbsenceModalData(absenceData);
                            setShowAbsenceModal(true);
                            return;
                        }
                        // Gestione del click su un appuntamento
                        else if (clickedEvent.extendedProps && clickedEvent.extendedProps.appointment) {
                            const appointmentData = clickedEvent.extendedProps.appointment;
                            
                            // Chiudi il pannello delle assenze se aperto
                            setShowAbsencePanel(false);
                            
                            // Verifica se è un appuntamento generico (isGenericAppointment=true oppure nessun jobId)
                            const isGeneric = appointmentData.isGenericAppointment === true || !appointmentData.jobId;
                            
                            if (isGeneric) {
                                // Apri modale specifica per appuntamenti generici
                                setGenericModalAppointment(appointmentData);
                                setShowGenericAppointmentModal(true);
                            } else {
                                // Apri modale standard per pianificazioni commessa
                                setModalAppointment(appointmentData);
                                setShowAppointmentModal(true);
                                
                                // Salva anche per riferimenti futuri
                                if (appointmentData.jobId) {
                                    setSelectedJobId(appointmentData.jobId);
                                    setSelectedAppointment(appointmentData);
                                }
                            }
                        } else {
                            toast.warning('Dettagli evento non disponibili');
                        }
                    },
                    select: function(arg) {
                        // Apri l'offcanvas di pianificazione rapida con la data selezionata
                        setSchedulingDate(arg.start);
                        setShowSchedulingOffcanvas(true);
                    },
                    dateClick: function(arg) {
                        // Apri l'offcanvas anche al click singolo su un giorno
                        setSchedulingDate(arg.date);
                        setShowSchedulingOffcanvas(true);
                    },
                    eventDrop: function(info) {
                        // Gestisce il drag and drop di un appuntamento su un altro giorno/orario
                        const event = info.event;
                        const extendedProps = event.extendedProps;
                        
                        // Ignora le assenze - non sono modificabili con drag & drop
                        if (extendedProps && extendedProps.isAbsence) {
                            info.revert();
                            toast.warning('Le assenze non possono essere spostate dal calendario');
                            return;
                        }
                        
                        // Estrai i dati dell'appuntamento
                        const appointment = extendedProps?.appointment;
                        if (!appointment) {
                            info.revert();
                            toast.error('Dati appuntamento non disponibili');
                            return;
                        }
                        
                        // Mostra la modal di conferma con opzioni notifiche
                        setRescheduleData({
                            appointment: appointment,
                            newStart: event.start,
                            newEnd: event.end,
                            changeType: 'drop',
                            revertFunc: info.revert
                        });
                        setShowRescheduleModal(true);
                    },
                    eventResize: function(info) {
                        // Gestisce il ridimensionamento (allungamento/accorciamento) di un appuntamento
                        const event = info.event;
                        const extendedProps = event.extendedProps;
                        
                        // Ignora le assenze - non sono modificabili con resize
                        if (extendedProps && extendedProps.isAbsence) {
                            info.revert();
                            toast.warning('Le assenze non possono essere modificate dal calendario');
                            return;
                        }
                        
                        // Estrai i dati dell'appuntamento
                        const appointment = extendedProps?.appointment;
                        if (!appointment) {
                            info.revert();
                            toast.error('Dati appuntamento non disponibili');
                            return;
                        }
                        
                        // Mostra la modal di conferma con opzioni notifiche
                        setRescheduleData({
                            appointment: appointment,
                            newStart: event.start,
                            newEnd: event.end,
                            changeType: 'resize',
                            revertFunc: info.revert
                        });
                        setShowRescheduleModal(true);
                    }
                });

                // Salviamo il riferimento all'API del calendario
                calendarApiRef.current = calendar;
                
                calendar.render();

                // Salviamo il riferimento all'API del calendario
                calendarApiRef.current = calendar;
                calendar.render();
                setCalendarInitialized(true);
                
                // Cleanup function
                return () => {
                    if (calendarApiRef.current) {
                        calendarApiRef.current.destroy();
                        calendarApiRef.current = null;
                    }
                };
            } catch (error) {
                console.error('Errore nel caricamento del calendario:', error);
                toast.error('Errore nel caricamento del calendario');
            } finally {
                setIsLoading(false);
            }
        };

        // Carica i dati dagli eventi e poi inizializza il calendario
        if (accountData?._id) {
            fetchCalendarEvents().then(() => {
                loadCalendarLibraries();
            });
        } else {
            loadCalendarLibraries(); // Se non abbiamo ancora accountData, inizializziamo comunque il calendario
        }

    }, [accountData, fetchEmployeeAbsences]); // Ri-esegui quando accountData o fetchEmployeeAbsences cambiano

    // Funzione per caricare l'elenco degli appuntamenti e convertirli in eventi per il calendario
    const fetchCalendarEvents = async () => {
        try {
            setIsLoading(true);
            
            // Ottieni l'ID account dell'utente loggato
            const accountId = accountData?._id;
            if (!accountId) {
                toast.error('ID account non disponibile');
                return;
            }
            
            // Calcola l'intervallo di date da visualizzare (±1 mese dalla data corrente per sicurezza)
            const today = new Date();
            const fromDate = new Date(today.getFullYear(), today.getMonth() - 1, 1).toISOString();
            const toDate = new Date(today.getFullYear(), today.getMonth() + 2, 0).toISOString();
            
            // Creiamo un oggetto params per la richiesta
            const params = {
                accountId,
                fromDate,
                toDate
            };
            
            // Aggiungi il filtro cliente se è stato selezionato
            if (selectedCustomer) {
                // Ora selectedCustomer è l'oggetto completo restituito da CustomerSelect
                params.customerId = selectedCustomer.value || selectedCustomer.id || selectedCustomer.data?.id;
            }
            
            // Aggiungi il filtro dipendenti se sono stati selezionati
            if (selectedEmployees && selectedEmployees.length > 0) {
                params.employeeIds = selectedEmployees.map(emp => emp.value).join(',');
            }
            
            // Chiamata API per ottenere gli appuntamenti usando il servizio centralizzato
            const response = await apiGet('appointments/bydate', params);
            
            // Trasforma i dati ricevuti nel formato richiesto da FullCalendar
            if (response.data && Array.isArray(response.data)) {
                const calendarEvents = response.data.map(appointment => {
                    // Gestione dei colori degli utenti
                    let backgroundColor = '#7367f0'; // Colore predefinito
                    let backgroundImage = '';
                    
                    // Controlla se ci sono utenti assegnati all'appuntamento
                    if (appointment.users && appointment.users.length > 0) {
                        // Se c'è un solo utente, usa il suo colore
                        if (appointment.users.length === 1 && appointment.users[0].userColor) {
                            backgroundColor = appointment.users[0].userColor;
                        } 
                        // Se ci sono più utenti, crea un effetto sfumato
                        else if (appointment.users.length > 1) {
                            // Raccogli i colori degli utenti, usa colori di default per utenti senza colore
                            const userColors = appointment.users.map(user => user.userColor || '#7367f0');
                            
                            // Limita a massimo 3 colori per l'effetto sfumato
                            const colorsToUse = userColors.slice(0, 3);
                            
                            // Crea un gradiente lineare con i colori
                            if (colorsToUse.length === 2) {
                                backgroundImage = `linear-gradient(to right, ${colorsToUse[0]}, ${colorsToUse[1]})`;
                                backgroundColor = 'transparent'; // Rende trasparente il colore di sfondo per mostrare il gradiente
                            } else if (colorsToUse.length >= 3) {
                                backgroundImage = `linear-gradient(to right, ${colorsToUse[0]}, ${colorsToUse[1]}, ${colorsToUse[2]})`;
                                backgroundColor = 'transparent'; // Rende trasparente il colore di sfondo per mostrare il gradiente
                            }
                        }
                    }
                    
                    // Crea la descrizione da mostrare al passaggio del mouse
                    let description = '';
                    if (appointment.jobCode) description += `Commessa: ${appointment.jobCode}<br>`;
                    if (appointment.systemLabel) description += `Impianto: ${appointment.systemLabel}<br>`;
                    if (appointment.systemAddressLabel) description += `Indirizzo: ${appointment.systemAddressLabel}<br>`;
                    if (appointment.notes) description += `Note: ${appointment.notes}<br>`;
                    
                    // Aggiungi informazioni sulle risorse
                    if (appointment.users && appointment.users.length > 0) {
                        description += 'Risorse: ' + appointment.users.map(user => user.userLabel).join(', ');
                    }
                    
                    return {
                        id: appointment._id,
                        title: appointment.title,
                        start: new Date(appointment.fromDate),
                        end: new Date(appointment.toDate),
                        backgroundColor: backgroundColor,
                        style: backgroundImage ? { backgroundImage: backgroundImage } : undefined,
                        description: description,
                        extendedProps: appointment // Manteniamo tutti i dati originali per riferimento
                    };
                });
                
                setEvents(calendarEvents);
            } else {
                setEvents([]);
                toast.warning('Nessun appuntamento trovato nel periodo selezionato');
            }
        } catch (error) {
            console.error('Errore nel caricamento degli eventi:', error);
            toast.error('Errore nel caricamento degli eventi');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="container-fluid d-flex flex-column" style={{ minHeight: 'calc(100vh - 60px)' }}>
            {/* Pannello laterale per i dettagli dell'appuntamento */}
            {rightModalIsOpen && (
                <RightModal>
                    {rightModalMode === 'view' && selectedJobId && (
                        <ViewJob 
                            jobId={selectedJobId} 
                            appointmentId={selectedAppointment?._id} 
                            calendarView={true}
                        />
                    )}
                    
                    {rightModalMode === 'appointment_view' && rightModalData && (
                        <ViewAppointment 
                            appointment={rightModalData} 
                            initialEditMode={rightModalData.initialEditMode || false}
                        />
                    )}
                </RightModal>
            )}
            
            {/* Pannello dettagli assenza */}
            {showAbsencePanel && selectedAbsence && (
                <div className="absence-panel-container position-fixed" style={{
                    right: '20px',
                    top: '80px',
                    zIndex: 1050,
                    width: '400px',
                    maxWidth: '90vw'
                }}>
                    <AbsenceDetailsPanel 
                        absence={selectedAbsence} 
                        onClose={() => setShowAbsencePanel(false)} 
                    />
                </div>
            )}
            
            {/* Header con filtri e pulsante pianificazione */}
            <div className="row px-4 py-3">
                <div className="col-12 d-flex justify-content-between align-items-center">
                    {/* Filtri a sinistra */}
                    <div className="d-flex align-items-start gap-3">
                        {/* Icona filtro */}
                        <div className="d-flex align-items-center" style={{ marginTop: '2rem' }}>
                            <FontAwesomeIcon 
                                icon={faFilter} 
                                className="me-2" 
                                style={{ 
                                    fontSize: '1.2rem',
                                    color: '#4a5568'
                                }}
                            />
                        </div>
                        
                        {/* Select Cliente - nascosto quando l'offcanvas è aperto */}
                        {!showSchedulingOffcanvas && !showGenericEditOffcanvas && (
                        <div>
                            <label htmlFor="customer-select" className="block mb-2 font-medium text-sm text-gray-700">Cliente:</label>
                            <div style={{ width: "400px" }}>
                                <DropdownWrapper>
                                    <CustomerSelect
                                        value={selectedCustomer}
                                        onChange={(selected) => {
                                            // Salviamo l'intero oggetto selected per mantenere il formato corretto
                                            setSelectedCustomer(selected);
                                            if (selected) {
                                                toast.info(`Filtro cliente: ${selected.label}`);
                                            } else {
                                                setSelectedCustomer(null);
                                                toast.info(`Filtro cliente rimosso - Mostrando tutti gli appuntamenti`);
                                            }
                                            // Aggiorna il calendario con il filtro cliente applicato/rimosso
                                            if (calendarApiRef.current) {
                                                // Salva il cliente selezionato in una variabile globale accessibile da tutta l'applicazione
                                                window.selectedCalendarCustomer = selected;
                                                calendarApiRef.current.refetchEvents();
                                            }
                                        }}
                                        placeholder="Cerca cliente..."
                                        classNamePrefix="calendar-select"
                                    />
                                </DropdownWrapper>
                            </div>
                        </div>
                        )}
                        
                        {/* Select Dipendenti - nascosto quando l'offcanvas è aperto */}
                        {!showSchedulingOffcanvas && !showGenericEditOffcanvas && (
                        <div>
                            <label htmlFor="employee-select" className="block mb-2 font-medium text-sm text-gray-700">Dipendenti:</label>
                            <div style={{ width: '500px' }}>
                                <DropdownWrapper>
                                    <EmployeeSelect 
                                        selectedOptions={selectedEmployees}
                                        setSelectedOptions={(selected) => {
                                            setSelectedEmployees(selected);
                                            // Aggiorna il calendario con il filtro dipendenti applicato
                                            if (calendarApiRef.current) {
                                                // Salva i dipendenti selezionati in una variabile globale accessibile da tutta l'applicazione
                                                window.selectedCalendarEmployees = selected;
                                                calendarApiRef.current.refetchEvents();
                                            }
                                        }}
                                        isMulti={true}
                                        placeholder="Seleziona dipendenti..."
                                        classNamePrefix="calendar-select"
                                    />
                                </DropdownWrapper>
                            </div>
                        </div>
                        )}
                    </div>
                    
                    {/* Pulsante Pianifica Commesse a destra */}
                    <div>
                        <button 
                            className="d-flex align-items-center justify-content-center rounded-lg px-4 py-2 text-white font-medium transition-all shadow-sm hover:shadow-md"
                            style={{
                                backgroundColor: '#383838',
                                border: 'none',
                                fontSize: '0.95rem',
                                letterSpacing: '0.01em'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#2a2a2a'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#383838'}
                            onClick={() => {
                                window.location.href = '/jobs/scheduling';
                            }}
                        >
                            <FontAwesomeIcon icon={faCalendarPlus} className="me-2" />
                            Pianifica Commesse
                        </button>
                    </div>
                </div>
            </div>

            {/* Calendario principale */}
            <div className="row px-4 pb-4">
                <div className="col-12">
                    <div className="card border shadow-sm rounded-lg overflow-hidden">
                        <div className="card-header d-flex justify-content-between align-items-center bg-white py-3 px-4 border-bottom">
                            <div>
                                <h5 className="mb-0 font-semibold text-gray-800">Calendario</h5>
                            </div>
                        </div>
                        <div id="main-calendar-content" className="card-body p-0">
                            {isLoading && (
                                <div className="d-flex justify-content-center align-items-center" style={{height: '100%'}}>
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Caricamento...</span>
                                    </div>
                                </div>
                            )}
                            {/* Aggiungiamo un wrapper al calendario per uno stile personalizzato */}
                            <div className="calendar-wrapper p-2">
                                <div ref={calendarRef}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Offcanvas per pianificazione rapida */}
            <SchedulingOffcanvas
                isOpen={showSchedulingOffcanvas}
                onClose={() => setShowSchedulingOffcanvas(false)}
                selectedDate={schedulingDate}
                onSuccess={() => {
                    // Ricarica gli eventi del calendario dopo la creazione
                    refreshCalendar();
                }}
            />
            
            {/* Modale dettagli appuntamento */}
            <AppointmentDetailsModal
                isOpen={showAppointmentModal}
                toggle={() => setShowAppointmentModal(false)}
                appointment={modalAppointment}
                onEdit={(apt, editType) => {
                    setShowAppointmentModal(false);
                    // Apri il pannello di modifica appuntamento
                    if (apt) {
                        setSelectedJobId(apt.jobId);
                        setSelectedAppointment({ ...apt, editType });
                        dispatch(setModal({ 
                            mode: 'appointment_view', 
                            percentuageWidth: 50,
                            data: { ...apt, editType, initialEditMode: true }
                        }));
                    }
                }}
                onDelete={(apt, deleteType) => {
                    // Chiudi la modal dei dettagli e apri la modal di eliminazione con notifiche
                    setShowAppointmentModal(false);
                    const isMultiDay = !!(apt.groupId || apt.planningId || apt.schedulingId || 
                        (apt.relatedAppointments && apt.relatedAppointments.length > 0));
                    setDeleteModalData({
                        appointment: apt,
                        isMultiDay: isMultiDay
                    });
                    setShowDeleteModal(true);
                }}
                onViewDetails={(apt) => {
                    setShowAppointmentModal(false);
                    // Apri il pannello laterale con i dettagli della commessa
                    if (apt.jobId) {
                        setSelectedJobId(apt.jobId);
                        setSelectedAppointment(apt);
                        dispatch(setModal({ mode: 'view', percentuageWidth: 80 }));
                    }
                }}
            />
            
            {/* Modale conferma reschedule (drag & drop / resize) */}
            <AppointmentRescheduleModal
                isOpen={showRescheduleModal}
                onClose={() => setShowRescheduleModal(false)}
                appointment={rescheduleData.appointment}
                newStart={rescheduleData.newStart}
                newEnd={rescheduleData.newEnd}
                changeType={rescheduleData.changeType}
                onSuccess={() => {
                    // Ricarica gli eventi del calendario dopo la modifica
                    refreshCalendar();
                    setShowRescheduleModal(false);
                }}
                onCancel={() => {
                    // Ripristina la posizione originale dell'evento
                    if (rescheduleData.revertFunc) {
                        rescheduleData.revertFunc();
                    }
                    setShowRescheduleModal(false);
                }}
            />
            
            {/* Modale conferma eliminazione appuntamento con notifiche */}
            <AppointmentDeleteModal
                isOpen={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                appointment={deleteModalData.appointment}
                isMultiDay={deleteModalData.isMultiDay}
                onSuccess={() => {
                    // Ricarica gli eventi del calendario dopo l'eliminazione
                    refreshCalendar();
                    setShowDeleteModal(false);
                }}
                onCancel={() => {
                    setShowDeleteModal(false);
                }}
            />
            
            {/* Modale dettagli appuntamento generico */}
            <GenericAppointmentDetailsModal
                isOpen={showGenericAppointmentModal}
                toggle={() => setShowGenericAppointmentModal(false)}
                appointment={genericModalAppointment}
                onEdit={(apt) => {
                    setShowGenericAppointmentModal(false);
                    setGenericEditAppointment(apt);
                    setShowGenericEditOffcanvas(true);
                }}
                onDelete={(apt) => {
                    // Chiudi la modal dei dettagli e apri direttamente la modal di eliminazione con notifiche
                    setShowGenericAppointmentModal(false);
                    setDeleteModalData({
                        appointment: apt,
                        isMultiDay: false
                    });
                    setShowDeleteModal(true);
                }}
            />
            
            {/* Offcanvas modifica appuntamento generico */}
            <GenericAppointmentEditOffcanvas
                isOpen={showGenericEditOffcanvas}
                onClose={() => setShowGenericEditOffcanvas(false)}
                appointment={genericEditAppointment}
                onSuccess={() => {
                    refreshCalendar();
                    setShowGenericEditOffcanvas(false);
                }}
            />
            
            {/* Modale dettagli assenza */}
            <AbsenceDetailsModal
                isOpen={showAbsenceModal}
                toggle={() => setShowAbsenceModal(false)}
                absence={absenceModalData}
                onEdit={(absence) => {
                    // Prepara i dati per l'offcanvas di modifica
                    setAbsenceToEdit({
                        _id: absence.absenceId,
                        userId: absence.userId,
                        userLabel: absence.userLabel,
                        absenceType: absence.absenceType,
                        absenceTypeId: absence.absenceTypeId,
                        start: absence.start,
                        end: absence.end,
                        notes: absence.notes,
                        approved: absence.approved
                    });
                    setShowAbsenceOffcanvas(true);
                }}
            />
            
            {/* Offcanvas modifica assenza */}
            <AbsenceOffcanvas
                isOpen={showAbsenceOffcanvas}
                onClose={() => {
                    setShowAbsenceOffcanvas(false);
                    setAbsenceToEdit(null);
                }}
                absenceData={absenceToEdit}
                onSuccess={() => {
                    refreshCalendar();
                    setShowAbsenceOffcanvas(false);
                    setAbsenceToEdit(null);
                }}
                absenceTypes={accountData?.settings?.employeeAbsenceTypes?.map(type => ({
                    id: type.code,
                    text: type.label,
                    color: type.color,
                    _id: type._id
                })) || []}
            />
        </div>
    );
};

export default JobsCalendar;
